import React, { useMemo, useRef } from "react";
import format from "date-fns/format";
import useClx from "../../hooks/use-clx";
import clxs from "./villa-item.module.css";
import { useShowModal } from "../../hooks/use-modal";
import CHEVRON_RIGHT_PRIMARY1 from "../../assets/icons/black-right-arrow-icon.svg";
import Infinity_Pool_Icon from "../../assets/icons/infinitypool-logo.svg";
//import CHEVRON_RIGHT_PRIMARY2 from "../../assets/lohono-black/icons/chevron-right-primary.svg";
//import LOHONO_BLACK_LOGO from "../../assets/lohono-black/logo/lohono-black.svg";
import Carousel from "../Carousel";
import Item from "../Carousel/Item";
import NetworkImg from "../NetworkImg";
import ScrollCrumb from "../Home/PropertyCarousel/ScrollCrumb";
import RatingCounts from "../PropertyDetail/RatingCounts";
import LoyaltyPointShortTicker from "../LoyaltyPointShortTicker";
import useIsMobile from "../../hooks/use-is-mobile";
import VillaTag from "../PropertyItem/VillaTag";

interface VillaItemProps {
  property: PropertyItem;
  className?: string;
  handleShowDetailForm?:( property: PropertyItem) => void;
  isDetailForm?:boolean;
}

function VillaItem(props: VillaItemProps) {
  const {
      property,
      className,
      handleShowDetailForm,
      isDetailForm,
    } = props,
    ccx = useClx(clxs.container, className),
    carouselRef = useRef<HTMLDivElement | null>(null),
    { isMobile } = useIsMobile(),
    {
      //location_slug,
      property_slug,
      name,
      address,
      accommodation,
      pool_count,
      bath_count,
      currency_symbol,
      rate,
      discounted_rate,
      sold_out,
      upcoming,
      status,
      //brand,
      bedroom_count,
      configs,
      next_availability,
      images,
      //builder,
      discount_method,
      discount_type,
      discount_value,
      average_ratings,
      ratings_count,
      tagsName,
      tagsIcon,
      collections,
      bundeled_offer,
      view_layout,
      //coupon_code,
    } = property,
    // isShowDiscountedPrice =
    //   discounted_rate > 0 && rate > 0 && discounted_rate < rate,
    // finalPrice = discounted_rate || rate,
    carouselId = useMemo(
      () =>isDetailForm ? `${FORM_CAROUSEL_ID}-${property_slug}` : `${CAROUSEL_ID}-${property_slug}`,
      [property_slug],
    ),
    isUnavailable = useMemo(
      () => status === "unavailable" || upcoming,
      [status, upcoming],
    ),
    // isBlack = useMemo(
    //   () => brand === "lohono_black",
    //   [brand],
    // ),
    // builderBadge = useMemo(
    //   () => {
    //     if (isBlack) {
    //       return (
    //         <img
    //           src={LOHONO_BLACK_LOGO}
    //           alt="lohono-black"
    //           className={clxs.badge}
    //         />
    //       );
    //     }
    //     return null;
    //   },
    //   [builder, isBlack],
    // ),
    finalPrice = useMemo(
      () => {
        const finalPrice = discounted_rate || rate;
        if (discounted_rate || rate) {
          return `${currency_symbol} ${(finalPrice).toLocaleString("en-IN")}`;
        }
        return null;
      },
      [discounted_rate, rate, currency_symbol],
    ),
    strikePrice = useMemo(
      () => {
        if (!discounted_rate) {
          return "";
        }
        if (discounted_rate == rate) {
          return "";
        }
        return `${currency_symbol} ${rate.toLocaleString("en-IN")}`;
      },
      [discounted_rate, rate, currency_symbol],
    ),
    specs = useMemo(() => {
      const specs: string[] = [`${accommodation} Guests`];

      if (view_layout === "multi_config") {
        specs.push(
          `${bedroom_count} ${bedroom_count > 1 ? "Bedrooms" : "Bedroom"}`,
        );
      } else if (configs.length) {
        // const partial = configs.map((each) => each.bedrooms).join(", ");

        specs.push(`${bedroom_count} ${bedroom_count == 1 ? "Bedroom" : "Bedrooms"}`);
      }

      if (bath_count) {
        specs.push(
          `${bath_count} ${bath_count > 1 ? "Bathrooms" : "Bathroom"}`,
        );
      }

      if (pool_count) {
        specs.push(`${pool_count} ${pool_count > 1 ? "Pools" : "Pool"}`);
      }

      return specs;
    }, [accommodation, bath_count, pool_count, configs]),
    nextAvailableDateNode = useMemo(
      () => {
        if (!sold_out) {
          return null;
        }

        const { checkin_date, checkout_date } = next_availability;

        if (!checkin_date || !checkout_date) {
          return null;
        }

        const checkin = format(new Date(checkin_date), "d LLL"),
          checkout = format(new Date(checkout_date), "d LLL");

        return (
          <div className={clxs.datesContainer}>
            {isMobile ? "- Next Available Dates" : "Next Available Dates"}
            <div className={clxs.dates}>
              {isMobile ? ` : ${checkin} - ${checkout}` : `${checkin} - ${checkout}`}
            </div>
          </div>
        );

      },
      [
        next_availability,
        sold_out,
        clxs.datesContainer,
        clxs.dates,
      ],
    ),
    tickerNode = useMemo(
      () => {
        if (upcoming) {
          return (
            <div className={clxs.upcoming}>
              Coming soon
            </div>
          );
        }

        if (sold_out) {
          return (
            <div className={clxs.soldOut}>
              Sold out
            </div>
          );
        }

        if (isUnavailable) {
          return (
            <div className={clxs.unavailable}>
              Unavailable
            </div>
          );
        }

        return null;
      },
      [upcoming, sold_out, isUnavailable],
    ),
    renderSoldOut = useMemo(() => {
      //If soldout or upcomming is true and nextAvailableDate is not present then
      const condition1 = (upcoming || sold_out) && !nextAvailableDateNode;

      //If sold_out ,upcoming ,isUnavailable is true
      const condition2 = sold_out || upcoming || isUnavailable;

      if (condition1) {
        return <div className={ratings_count ? clxs.soloSoldOut : `${clxs.soloSoldOut} ${clxs.leftContainer}`}>{tickerNode}</div>;
      } else if (condition2) {
        return (
          <div className={ratings_count && average_ratings ? clxs.soldOutContainer : `${clxs.soldOutContainer} ${clxs.leftContainer}`}>
            {tickerNode}
            {nextAvailableDateNode}
          </div>
        );
      } else {
        return null;
      }
    }, [sold_out, upcoming, nextAvailableDateNode, isUnavailable]),
    showGalleryModal = useShowModal(GALLERY_MODAL_ID),
    handleShowGallery = () => showGalleryModal({ images:images ?? [] }),
    onClickDetailForm = () => {
      handleShowDetailForm?.(property)
    };

  return (
    <>
      <div 
        className={ccx} 
        title={name}
      >
      <div
        className={clxs.thumbnailContainer}
      >
          <Carousel
            className={isDetailForm ? `${clxs.thumbnail} ${clxs.thumbnailMargin} `:clxs.thumbnail}
            id={carouselId}
            threshold={0.98}
            forwardRef={carouselRef}
          >
          {images.map((each, key) => {
            const { url, alt } = each;
            return (
              <Item 
                className={clxs.item} 
                key={key}
                onClick={handleShowGallery}
              >
                <NetworkImg
                  src={url}
                  alt={alt}
                  className={clxs.imgSelect}
                  {...(key !== 0 && { loading: "lazy" })}
                />  
              </Item>
            );
          })}
        </Carousel>
        <ScrollCrumb
          carouselId={carouselId}
          count={images.length}
          className={clxs.scrollCrumb}
          isShowArrows={true}
          isFilledArrows={true}
        />
      </div>
      <h3
        className={clxs.title}
        style={{ gridColumn: (((ratings_count && average_ratings) || sold_out) ? "span 2" : "span 3") }}
        title={name}
      >
        {name}
      </h3>
      {/* Check if both ratings_count and average_ratings */}
      {(ratings_count && average_ratings) ?
        <RatingCounts
          className={clxs.ratingCounts}
          average_ratings={average_ratings}
          ratings_count={ratings_count}
          theme="propertyItemRating"
        /> : null}
      <div className={clxs.subtitle}>
        {address}
      </div>
      <div className={clxs.specContainer}>
        {specs?.map(
          (each, i) => (
            <div
              key={i}
              className={clxs.spec}
            >
              {each} <span className={clxs.dot}>&#x2022;</span>
            </div>
          ),
        )}
      </div>

      {collections?.length ?
        <div className={clxs.collectionContainer}>
          {collections?.map(
            (each, i) => (
              <div
                key={i}
                className={clxs.collectionContent}
              >
                <img
                  src={each.icon ? each.icon : Infinity_Pool_Icon}
                  alt={each.slug}
                  className={clxs.collectionIcon}
                />
                <div className={clxs.collection}>
                  {each.name}
                </div>
              </div>
            ),
          )}
        </div>
        :
        <div className={clxs.hideCollection}></div>
      }

      {isUnavailable || isDetailForm ? null : (
        <div 
          className={ collections?.length ? clxs.pricingContainer : `${clxs.pricingContainer} ${clxs.priceHeight}`}
          onClick={()=>onClickDetailForm()}
        >
          {configs.length > 1 ? <div className={clxs.bedroomCount}>For {bedroom_count} rooms</div> : null}

          <div className={clxs.priceContainer}>
            {strikePrice ?
              <div className={clxs.startFrom}>
                {discount_value  ?
                <LoyaltyPointShortTicker
                  discountType={discount_type}
                  discountPercentage={discount_value}
                  method={discount_method}
                  currencySymbol={currency_symbol}
                  className={clxs.llpTicker}
                /> : null }
                {strikePrice ? (
                  <span className={clxs.strike}>
                    {strikePrice}
                  </span>
                ) : null}
              </div>
              : null
            }
            <div
              className={clxs.price}
              data-sold-out={sold_out}
            >

              <span className={clxs.amount}>
                {finalPrice ? finalPrice : "-"}
              </span>
              <span className={clxs.excTax}>{isMobile ? "/ Night + Taxes*" : "Per Night + Taxes*"}</span>
            </div>

          </div>

          <div
            className={clxs.view}
            data-sold-out={sold_out}
          >
            <span>
              View details
            </span>
            <img
              src={CHEVRON_RIGHT_PRIMARY1}
              alt="jump"
              className={clxs.viewIcon}
            />
          </div>
        </div>
      )}
      {/* {builderBadge} */}
      {renderSoldOut}
      {bundeled_offer ?
        <div className={clxs.additionalBenefitsContainer}>
          <div className={clxs.additionalBenefits}>Additional benefits on</div>
          <div className={clxs.benefitsContainer}>
            <img
              // src={isMobile ? fork_spoon_color_icon : fork_spoon_icon}
              src={bundeled_offer.icon}
              alt="Lohono"
              className={clxs.benefitsIcon}
            />
            <span className={clxs.benefitsContent}>{bundeled_offer.name}</span>
          </div>
        </div>
        : null
      }
      {tagsName &&
        <div className={clxs.VillaTagContainer}>
          <VillaTag
            tag={tagsName}
            icon={tagsIcon}
            className=""
          />
        </div>
      }
        
      </div>
    </>
  );
}


export default VillaItem;

const GALLERY_MODAL_ID = "villa-gallery-mobile";

const CAROUSEL_ID = "villa-details-image";

const FORM_CAROUSEL_ID = "form-villa-details-image";
